import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const DetailedSubheading = styled.h4(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { detailedSubheading }, }, }, }, }) => css `
      ${renderTextVariations(detailedSubheading, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { DetailedSubheading as default };
